const initialState = {
  franquicia: null,
};

const fFranquicia = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FFRANQUICIA':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default fFranquicia;
